export default "__VITE_ASSET__CERSMf$P__"